import { PermissionsEnum } from "@/auth/interfaces";
import { CustomTabPanel } from "@/erp/sale";
import { a11yProps, hasPermission, ROUTER_PATHS, sizeTab, texto } from "@/shared";
import { SingleTableBoxScene } from "@/shared/components/ui";
import { Box, Tab, Tabs } from "@mui/material";
import { useState } from "react";
import TablaSolicitudIngresoPage from "../TablaSolicitudIngresoPage/TablaSolicitudIngresoPage";
import { EstadosSolicitudIngresoEnum } from "@/shared/interfaces";

const SolicitudIngresoPage = () => {
  const returnUrl = ROUTER_PATHS.inventario.solicitud_ingreso_compraNav
  const [valueTab, setValueTab] = useState(0);
  return (
    <SingleTableBoxScene title={"Solicitud de Compra"}
      urlRedirect={`${returnUrl}/crear`}
      enableRedirect={hasPermission(PermissionsEnum.api_add_solicitudingreso)}

    >
      <Box sx={{ bgcolor: 'background.paper', maxWidth: sizeTab, paddingBottom: 2 }}
      >
        <Tabs
          value={valueTab}
          onChange={(_event: React.SyntheticEvent, newValue: number) => {
            setValueTab(newValue);
          }}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          aria-label="scrollable force tabs solicitud pedidos"
        >
          <Tab label={texto.solicitud_espera} {...a11yProps(0)} />
          <Tab label={texto.solicitudes_aprobadas} {...a11yProps(1)} />
          <Tab label={texto.solicitud_rechazada} {...a11yProps(2)} />
        </Tabs>
      </Box>

      <CustomTabPanel value={valueTab} index={0}>
        <TablaSolicitudIngresoPage estado={EstadosSolicitudIngresoEnum.ESPERA} />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={1}>
        <TablaSolicitudIngresoPage estado={EstadosSolicitudIngresoEnum.APROBADAS} />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={2}>
        <TablaSolicitudIngresoPage estado={EstadosSolicitudIngresoEnum.RECHAZADO} />
      </CustomTabPanel>

    </SingleTableBoxScene>
  )
}
export default SolicitudIngresoPage